import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import { useCart } from '../../context/CartContext';
import { img, taka } from './shopUtils';

export const firstAvailable = (p) => p.variants?.find((v) => v.stock > 0);

export const ProductCard = ({ p, paused }) => {
  const { language, t } = useLanguage();
  const navigate = useNavigate();
  const cart = useCart();
  const v = firstAvailable(p);
  const needsChoice = (p.colours?.length > 1) || (p.sizes?.length > 1);
  const primary = language === 'bn' ? p.name.bn || p.name.en : p.name.en;
  const secondary = language === 'bn' ? p.name.en : p.name.bn;

  const add = () => {
    if (needsChoice) return navigate(`/shop/${p.slug}`);
    cart.add({ slug: p.slug, variant_sku: v.sku, qty: 1, price: p.price, name: p.name, image: p.images?.[0], colour: v.colour, size: v.size, max: v.stock });
  };

  return (
    <article className="shop-card group flex flex-col overflow-hidden" data-testid={`product-card-${p.slug}`}>
      <button onClick={() => navigate(`/shop/${p.slug}`)} className="relative aspect-[4/3] overflow-hidden bg-[#F3F0EA]" aria-label={primary}>
        <img src={img(p.images?.[0])} alt={`${p.name.en} · ${p.name.bn || ""}`} loading="lazy" width="400" height="300" className="h-full w-full object-cover" />
        {p.best && <span className="absolute left-3 top-3 rounded bg-[#E31E24] px-2 py-0.5 text-[11px] font-semibold text-white" data-testid={`best-badge-${p.slug}`}>{t({ en: 'Best seller', bn: 'বেস্ট সেলার' })}</span>}
      </button>
      <div className="flex flex-1 flex-col p-4">
        <h3 className="font-semibold leading-snug text-[#0A0A0A]">{primary}</h3>
        {secondary && <p className="text-sm text-[#6B7280]">{secondary}</p>}
        <p className="mt-2 font-semibold text-[#0A0A0A]" data-testid={`product-price-${p.slug}`}>
          {paused ? <span className="text-sm font-normal text-[#6B7280]">{t({ en: 'Store paused', bn: 'স্টোর বন্ধ' })}</span> : taka(p.price, language)}
          {!paused && (p.note?.[language] || p.note?.en) && <span className="ml-2 text-xs font-normal text-[#6B7280]">{p.note[language] || p.note.en}</span>}
        </p>
        <div className="mt-auto flex gap-2 pt-4">
          <button onClick={() => navigate(`/shop/${p.slug}`)} className="shop-btn flex-1 border border-[#E5E7EB] text-[#0A0A0A] hover:border-[#0A0A0A]" data-testid={`view-product-${p.slug}`}>{t({ en: 'View', bn: 'দেখুন' })}</button>
          {!paused && (
            <button onClick={add} disabled={!v} className="shop-btn flex-1 bg-[#0E9A49] text-white hover:bg-[#0b7f3c] disabled:opacity-50" data-testid={`add-to-cart-${p.slug}`}>
              {v ? t({ en: 'Add to cart', bn: 'কার্টে যোগ' }) : t({ en: 'Sold out', bn: 'স্টক শেষ' })}
            </button>
          )}
        </div>
      </div>
    </article>
  );
};
